import { render, staticRenderFns } from "./FilesContent.vue?vue&type=template&id=00dcec00&scoped=true&"
import script from "./FilesContent.vue?vue&type=script&lang=js&"
export * from "./FilesContent.vue?vue&type=script&lang=js&"
import style0 from "./FilesContent.vue?vue&type=style&index=0&id=00dcec00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dcec00",
  null
  
)

export default component.exports